import { Menu } from 'ui/menu/Menu';
import { ALIGNMENT } from 'ui/menu/constants';
import { World } from 'ui/icons/other/World';
import { colors, spacing } from 'ui/theme';
import { useCurrentLocale } from 'utils/hooks/useTranslation';
import { I18N_MENU_OPTIONS } from './constants';
import { Wrapper, Text } from './I18nSelector.styled';

/**
 * TODO
 * Look into adding a method to `detectLocale`
 * https://github.com/Iterable/iterable-frontend/pull/5113#discussion_r829373807
 *
 */

export const I18nSelector = () => {
  const { language, changeLanguage } = useCurrentLocale();

  return (
    <Wrapper>
      <Menu
        options={I18N_MENU_OPTIONS}
        verticalAlignment={ALIGNMENT.UP}
        handleSelectionChange={changeLanguage}
      >
        <World
          data-test="footer-i18n-icon"
          color={colors.grey50}
          style={{ marginRight: spacing.half }}
        />
        <Text>{language}</Text>
      </Menu>
    </Wrapper>
  );
};
